import { c as _c } from "react/compiler-runtime";
import './donate-shim.scss';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { DonateCard } from '../_logic/donate-card.tsx';
export const DonateShim: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(8);
  let props;
  let seoLevel;
  if ($[0] !== t0) {
    ({
      seoLevel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = seoLevel;
  } else {
    props = $[1];
    seoLevel = $[2];
  }
  let t1;
  if ($[3] !== props || $[4] !== seoLevel) {
    t1 = props.fund && <DonateCard {...props} seoLevel={seoLevel} />;
    $[3] = props;
    $[4] = seoLevel;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className="DonateShim component component--container"><div className="DonateShim__container container"><div className="max-w-md mx-auto">{t1}</div></div></div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};